import type { AnalyticsEvent, SandboxLead } from '../types/funnel';

const LEADS = 'im_sandbox_leads_v1';
const EVENTS = 'im_sandbox_events_v1';

function read<T>(key: string): T[] {
  try {
    return JSON.parse(localStorage.getItem(key) ?? '[]') as T[];
  } catch {
    return [];
  }
}

export function listLeads(): SandboxLead[] {
  return read<SandboxLead>(LEADS);
}

export function saveLead(lead: SandboxLead): void {
  const all = listLeads().filter((l) => l.id !== lead.id);
  localStorage.setItem(LEADS, JSON.stringify([lead, ...all].slice(0, 50)));
}

export function listEvents(): AnalyticsEvent[] {
  return read<AnalyticsEvent>(EVENTS);
}

/** Sandbox event ledger. Deduplicates by eventId. Nothing is sent to Meta from the preview. */
export function recordEvent(name: string, dedupeKey: string, props: Record<string, string | number> = {}): void {
  const eventId = `${name}:${dedupeKey}`;
  const all = listEvents();
  if (all.some((e) => e.eventId === eventId)) return;
  const evt: AnalyticsEvent = { eventId, name, at: new Date().toISOString(), sandbox: true, forwarded: false, props };
  localStorage.setItem(EVENTS, JSON.stringify([evt, ...all].slice(0, 200)));
}

export function clearSandbox(): void {
  localStorage.removeItem(LEADS);
  localStorage.removeItem(EVENTS);
}

export function newId(prefix: string): string {
  return `${prefix}-${Date.now().toString(36).toUpperCase().slice(-5)}${Math.random().toString(36).slice(2, 5).toUpperCase()}`;
}
